var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.9375L5.90938 16.1648C5.81781 16.0481 5.72718 15.9307 5.63751 15.8125C4.51171 14.3295 3.90353 12.5181 3.90626 10.6562C3.90626 8.37705 4.81167 6.19119 6.42331 4.57955C8.03495 2.96791 10.2208 2.0625 12.5 2.0625C14.7792 2.0625 16.9651 2.96791 18.5767 4.57955C20.1883 6.19119 21.0938 8.37705 21.0938 10.6562C21.0965 12.5173 20.4886 14.3278 19.3633 15.8102L19.3625 15.8125C19.3625 15.8125 19.1281 16.1203 19.093 16.1617L12.5 23.9375ZM6.88438 14.8711C6.88595 14.8711 7.0672 15.1117 7.1086 15.1633L12.5 21.5219L17.8984 15.1547C17.9328 15.1117 18.1156 14.8695 18.1164 14.8688C19.0361 13.6571 19.5331 12.1774 19.5313 10.6562C19.5313 8.79145 18.7905 7.00302 17.4719 5.68441C16.1532 4.36579 14.3648 3.625 12.5 3.625C10.6352 3.625 8.84678 4.36579 7.52816 5.68441C6.20955 7.00302 5.46876 8.79145 5.46876 10.6562C5.46712 12.1783 5.96468 13.6589 6.88516 14.8711H6.88438Z",
    fill: "#1160AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 14.5625H14.8438V8.3125H10.1562V14.5625H8.59375V8.3125C8.59416 7.89823 8.75892 7.50104 9.05185 7.2081C9.34479 6.91517 9.74198 6.75041 10.1562 6.75H14.8438C15.258 6.75041 15.6552 6.91517 15.9481 7.2081C16.2411 7.50104 16.4058 7.89823 16.4062 8.3125V14.5625Z",
    fill: "#1160AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 13H13.2812V14.5625H11.7188V13Z",
    fill: "#1160AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 9.875H13.2812V11.4375H11.7188V9.875Z",
    fill: "#1160AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon_company.a0dd15be959d855b1bce2290795b4e8d.svg";
export { ForwardRef as ReactComponent };